import EventStatsWidget from '@/screens/EventStatsWidget';

export default function ExternalWidgetV1StatsEventIdRoute() {
  return <EventStatsWidget />;
}
